<!-- @format -->

<template>
	<pc-mo-image-upload
		v-model="fileList"
		:convert-res-to-front-data="convertResToFrontData"
		:upload-file="fileUpload"
		name="file"
		v-bind="$attrs"
	/>
</template>

<script setup lang="ts">
	import { isImageTypeResPath } from '@power/utils';
	import { fileUpload, getFilePreviewUrlById, getEnvUrlByUrl } from '@power/runtime-vue3';

	import { PcMoImageUpload } from '@/components';
	import { getFilesByIds } from '@/api/global';

	interface Props {
		modelValue: string | Array<string>; // 逗号分隔的字符串或者是字符串数组
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});
	const fileList = ref<any>([]);
	const modelValue = computed({
		get() {
			return props.modelValue;
		},
		set(val) {
			emit('update:modelValue', val);
		},
	});
	/**
	 * 根据后端返回的数据进行处理成前端展示用的数据
	 * @param {*} data
	 */
	function convertResToFrontData(data) {
		console.log('convertResToFrontData.data', data);

		const frontData = { ...data };
		if (data.resourceName) {
			frontData.version = 'V2';
			let resType = '';
			if (isImageTypeResPath(data.resourceName)) {
				resType = 'img';
			} else {
				resType = 'video';
			}
			frontData.resType = resType;
			frontData.name = data.resourceName;
			// frontData.isImage = true;
			if (data.id) {
				frontData.url = getFilePreviewUrlById(data.id);
			}
		} else {
			frontData.version = 'V1';
			let resType = '';
			if (isImageTypeResPath(data.url)) {
				resType = 'img';
			} else {
				resType = 'video';
			}
			frontData.resType = resType;
		}

		return frontData;
	}

	const refreshFileList = async () => {
		const val = props.modelValue;
		const list = Array.isArray(val) ? val : val?.split(',') || [];
		const idsTmp = list.join(',');
		const ids = idsTmp
			.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/download?id=`), '')
			.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/preview?attachmentId=`), '');
		const res = await getFilesByIds({ ids });
		let newIds = '';
		const newIdsArr: any = [];

		fileList.value = res.map((item) => {
			newIdsArr.push(item.url);
			const { url, version } = item;
			let urlNew = url;
			if ('V1' === version) {
				// log
				urlNew = url;
			} else if ('V2' === version) {
				urlNew = getFilePreviewUrlById(url);
			}
			return {
				...item,
				url: urlNew,
			};
		});

		newIds = newIdsArr.join(',');
		if (ids !== newIds) {
			const isArray = Array.isArray(val);
			if (isArray) {
				modelValue.value = newIdsArr;
			} else {
				modelValue.value = newIds;
			}
		}
	};

	const refreshModelValue = async () => {
		const val = props.modelValue;
		const list = Array.isArray(val) ? val : val?.split(',') || [];
		const ids = list
			.join(',')
			.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/download?id=`), '')
			.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/preview?attachmentId=`), '');
		let newIds = '';
		const newIdsArr: any = [];

		fileList.value.map((item) => {
			const { url, version } = item;
			let urlNew: string = url;
			if ('V1' === version) {
				// log
				urlNew = url;
			} else if ('V2' === version) {
				urlNew = url
					.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/download?id=`), '')
					.replaceAll(getEnvUrlByUrl(`power-api/base/oss/file/preview?attachmentId=`), '');
			}
			newIdsArr.push(urlNew);

			return {
				...item,
				url: urlNew,
			};
		});

		newIds = newIdsArr.join(',');
		if (ids !== newIds) {
			const isArray = Array.isArray(val);
			if (isArray) {
				modelValue.value = newIdsArr;
			} else {
				modelValue.value = newIds;
			}
		}
	};
	const emit = defineEmits(['update:modelValue']);

	watch(
		() => props.modelValue,
		(val) => {
			//console.log('props.modelValue', val);
			if (val && val.length > 0) {
				refreshFileList();
			} else {
				fileList.value = [];
				return [];
			}
		},
	);

	watch(
		() => fileList.value,
		(val) => {
			//console.log('fileList.value', val);
			if (val && val.length > 0) {
				refreshModelValue();
			} else {
				modelValue.value = [];
				return [];
			}
		},
	);
</script>

<style scoped lang="scss">
	// .el-upload--picture-card 控制加号部分
	:deep(.hide .el-upload--picture-card) {
		display: none;
	}
</style>
